import script from "./step4RecruitmentTeam.vue?vue&type=script&setup=true&lang=ts"
export * from "./step4RecruitmentTeam.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__